import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Button } from 'ui-components/components/button';

import style from './style.module.less';
import HelpArticleLink from '../../../../../components/help-article-link';
import { linkIDs } from '../../../../../services/link-service/links';

const messages = defineMessages({
  checkConnectionSettings: {
    description: 'printModal.checkConnectionSettings',
    defaultMessage: 'ShipStation Connect is offline. Open and sign in to Connect, or <a>review our troubleshooting guide</a> for tips.',
    id: 'iaGbt0',
  },
  getShipStationConnect: {
    description: 'printModal.getShipStationConnect',
    defaultMessage: 'Get ShipStation Connect',
    id: 'lDKnfj',
  },
  installShipStationConnectMessage: {
    description: 'printModal.installShipStationConnectMessage',
    defaultMessage: "Install ShipStation Connect to print directly to your computer's printers.",
    id: 'YCTDcj',
  },
});

const hasOnlineWorkstations = (availablePrinters = []) => {
  return availablePrinters.reduce((memo, workstation) => {
    const { workstationIsOnline = false } = workstation;
    return memo || workstationIsOnline;
  }, false);
};

const renderCheckConnectionItem = () => {
  return (
    <div className={style['check-connection']}>
      <FormattedMessage
        {...messages.checkConnectionSettings}
        values={{
          a: (chunks) => <HelpArticleLink articleId={linkIDs.ShipStationConnectPathfinder}>{chunks}</HelpArticleLink>,
        }}
      />
    </div>
  );
};

export const PrinterHints = ({ availablePrinters, hasInstalledShipStationConnect = false }) => {
  const checkConnection = hasInstalledShipStationConnect && !hasOnlineWorkstations(availablePrinters);

  return (
    <React.Fragment>
      {checkConnection ? renderCheckConnectionItem() : null}
      {!hasInstalledShipStationConnect && (
        <div className={style['install-shipstation-connect']}>
          <div className={style['install-message']}>
            <FormattedMessage {...messages.installShipStationConnectMessage} />
          </div>
          <Button className={style['install-shipstation-connect-button']} href='/settings/connect' theme='link'>
            <FormattedMessage {...messages.getShipStationConnect} />
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};

PrinterHints.propTypes = {
  availablePrinters: PropTypes.array.isRequired,
  hasInstalledShipStationConnect: PropTypes.bool,
};
